module.exports = __webpack_public_path__ + "img/health-small.6316e7fc.jpg";